import React from "react";
import "./Service.css";

import {
  FaWhatsapp,
  FaArrowRight,
  FaCheckCircle,
  FaCouch,
  FaTools,
  FaLayerGroup,
} from "react-icons/fa";

export default function Service() {
  const WHATSAPP = "919318333680";

  const services = [
    {
      title: "Sofa Repair",
      desc: "Structural fixes, broken legs, frame and spring repairs.",
      src: `${process.env.PUBLIC_URL}/img/sofa_repair_img.png`,
      icon: <FaTools />,
    },
    {
      title: "Re-Upholstery",
      desc: "Fabric or leatherette change with neat stitching and piping.",
      src: `${process.env.PUBLIC_URL}/img/upholstery_img.jpg`,
      icon: <FaLayerGroup />,
    },
    {
      title: "Foam & Cushion Replacement",
      desc: "High-density foam, sagging seat makeover and custom sizes.",
      src: `${process.env.PUBLIC_URL}/img/form_img.jpg`,
      icon: <FaCouch />,
    },
    {
      title: "Recliner Repair",
      desc: "Handle, cable, motor and recliner mechanism service.",
      src: `${process.env.PUBLIC_URL}/img/recliner_img.jpg`,
      icon: <FaTools />,
    },
    {
      title: "Polish & Restoration",
      desc: "Wood touch-ups, colour matching and shine restoration.",
      src: `${process.env.PUBLIC_URL}/img/polish_img.jpg`,
      icon: <FaLayerGroup />,
    },
    {
      title: "New Custom Sofa",
      desc: "Tailor-made sofa designs for homes, offices and lounges.",
      src: `${process.env.PUBLIC_URL}/img/new_sofa.jpg`,
      icon: <FaCouch />,
    },
    {
      title: "Sofa Cum Bed Repair",
      desc: "Professional repair and restoration for sofa-cum-beds.",
      src: `${process.env.PUBLIC_URL}/img/sofa_cum_bed.webp`,
      icon: <FaTools />,
    },
    {
      title: "Leather Sofa Repair",
      desc: "Expert leather sofa repair, restoration and finishing.",
      src: `${process.env.PUBLIC_URL}/img/reclining_sofa.jpg`,
      icon: <FaLayerGroup />,
    },
    {
      title: "New Custom Bed",
      desc: "Custom-designed beds made according to your space and style.",
      src: `${process.env.PUBLIC_URL}/img/new_bed.webp`,
      icon: <FaCouch />,
    },
  ];

  const handleEnquiry = (title) => {
    const message = `Hi, I am interested in ${title} service. Please share details and pricing.`;

    window.open(
      `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <section className="services-section" id="services">

      {/* Decorative Elements */}
      <div className="services-bg-circle services-bg-circle-one"></div>
      <div className="services-bg-circle services-bg-circle-two"></div>

      <div className="container">

        {/* ================= HEADER ================= */}

        <div className="services-heading">

          <div className="services-heading-left">

            <span className="services-eyebrow">
              OUR SERVICES
            </span>

            <h2>
              Furniture care,
              <br />
              <span>done properly.</span>
            </h2>

          </div>

          <div className="services-heading-right">

            <p>
              From small repairs to complete transformations, we bring
              practical craftsmanship and premium finishing to your
              furniture.
            </p>

            <div className="services-heading-line">
              <span></span>
            </div>

          </div>

        </div>


        {/* ================= FEATURED SERVICE ================= */}

        <div className="featured-service">

          <div className="featured-image">

            <img
              src={services[0].src}
              alt={services[0].title}
              loading="lazy"
            />

            <div className="featured-image-shade"></div>

            <div className="featured-number">
              01
            </div>

            <div className="featured-image-label">
              <FaCheckCircle />
              PROFESSIONAL SERVICE
            </div>

          </div>


          <div className="featured-content">

            <span className="featured-small-title">
              FEATURED SERVICE
            </span>

            <div className="featured-icon">
              {services[0].icon}
            </div>

            <h3>
              {services[0].title}
            </h3>

            <p>
              {services[0].desc} Our experienced craftsmen inspect
              the sofa carefully and provide the right repair solution
              with reliable finishing.
            </p>

            <div className="featured-points">

              <span>
                <FaCheckCircle />
                Expert workmanship
              </span>

              <span>
                <FaCheckCircle />
                Quality materials
              </span>

              <span>
                <FaCheckCircle />
                Doorstep service
              </span>

            </div>

            <button
              className="featured-button"
              onClick={() => handleEnquiry(services[0].title)}
            >
              <FaWhatsapp />
              Enquire About This Service
              <FaArrowRight />
            </button>

          </div>

        </div>


        {/* ================= SERVICE LIST ================= */}

        <div className="services-top-row">

          <div>
            <span className="services-list-label">
              MORE SERVICES
            </span>

            <h3>
              Solutions for every
              <span> furniture need.</span>
            </h3>
          </div>

          <div className="services-count">
            <strong>08</strong>
            <span>MORE SERVICES</span>
          </div>

        </div>


        <div className="services-showcase">

          {services.slice(1).map((service, index) => {

            const number = String(index + 2).padStart(2, "0");

            return (
              <article
                className="showcase-card"
                key={service.title}
                onClick={() => handleEnquiry(service.title)}
              >

                <div className="showcase-image">

                  <img
                    src={service.src}
                    alt={service.title}
                    loading="lazy"
                  />

                  <div className="showcase-overlay"></div>

                  <span className="showcase-number">
                    {number}
                  </span>

                  <span className="showcase-icon">
                    {service.icon}
                  </span>

                </div>


                <div className="showcase-content">

                  <div className="showcase-title">

                    <h4>
                      {service.title}
                    </h4>

                    <FaArrowRight />

                  </div>

                  <p>
                    {service.desc}
                  </p>

                  <div className="showcase-bottom">

                    <span>
                      <FaCheckCircle />
                      Professional Work
                    </span>

                    <span className="showcase-enquire">
                      Enquire
                    </span>

                  </div>

                </div>

              </article>
            );
          })}

        </div>


        {/* ================= BOTTOM CTA ================= */}

        <div className="services-cta">

          <div className="services-cta-icon">
            <FaCouch />
          </div>

          <div className="services-cta-content">

            <span>
              NOT SURE WHAT YOU NEED?
            </span>

            <h3>
              Let our experts find the right solution.
            </h3>

            <p>
              Share a photo of your sofa and our team will guide you
              with the suitable repair or restoration option.
            </p>

          </div>

          <a
            href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent(
              "Hi, I need help regarding sofa repair service. I want to share a photo of my sofa."
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="services-cta-button"
          >
            <FaWhatsapp />
            Talk To Expert
            <FaArrowRight />
          </a>

        </div>

      </div>
    </section>
  );
}
